// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookings-widget {
  overflow: hidden;
}
.bookings-widget .bookings-container {
  display: flex;
  gap: 10px;
  flex: 1;
  min-height: 0;
}
.bookings-widget .meetings-list-container {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.bookings-widget .meetings-list-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.bookings-widget .meetings-list-container .meetings-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: -webkit-min-content;
  min-height: min-content;
}
.bookings-widget .meetings-list-container .meetings-list.no-meetings {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  text-align: center;
  color: #666;
  font-style: italic;
  border-radius: 8px;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item {
  padding-left: 6px;
  border-left: 4px solid;
  display: block;
  width: 100%;
  background: none;
  border-top: none;
  border-right: none;
  border-bottom: none;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.accepted {
  border-left-color: var(--ion-color-success);
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.declined {
  border-left-color: #ed143d;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.pending {
  border-left-color: var(--ion-color-warning);
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item.resourceless {
  border-left-color: #0078d4;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-subject {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-time {
  display: block;
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .meetings-list-container .meetings-list .meeting-item .meeting-resource {
  font-size: 11px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bookings-widget .info-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border-left: 3px solid #cccccc;
  width: 120px;
}
.bookings-widget .info-section {
  text-align: center;
  padding: 8px 4px;
  border-radius: 8px;
  line-height: 1.1;
}
.bookings-widget .info-section .value {
  font-size: clamp(16px, 2vw, 18px);
  font-weight: 600;
}
.bookings-widget .info-section .value.booking-date-time {
  display: flex;
  font-size: 14px;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
}
.bookings-widget .info-section .label {
  font-size: clamp(10px, 1.5vw, 12px);
  text-align: center;
  color: #666;
}
.bookings-widget .today-date-container {
  font-size: 13px;
  color: #ed143d;
}

.open-calendar-btn {
  background: transparent;
  font-size: 1.4rem;
}
.open-calendar-btn ion-icon {
  color: #ed143d;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/bookings-widget/bookings-widget.component.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAGE;EACE,aAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AADJ;AAIE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA,EAAA,YAAA;AAFJ;AAGI;EACE,aAAA,EAAA,0BAAA;AADN;AAII;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,+BAAA;EAAA,uBAAA;AAFN;AAGM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AADR;AAIM;EACE,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAFR;AAIQ;EACE,2CAAA;AAFV;AAKQ;EACE,0BAAA;AAHV;AAMQ;EACE,2CAAA;AAJV;AAOQ;EACE,0BAAA;AALV;AAQQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AANV;AASQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPV;AAUQ;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AARV;AAcE;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,8BAAA;EACA,YAAA;AAZJ;AAeE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAbJ;AAcI;EACE,iCAAA;EACA,gBAAA;AAZN;AAcM;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAZR;AAgBI;EACE,mCAAA;EACA,kBAAA;EACA,WAAA;AAdN;AAiBE;EACE,eAAA;EACA,cAAA;AAfJ;;AAmBA;EACE,uBAAA;EACA,iBAAA;AAhBF;AAiBE;EACE,cAAA;AAfJ","sourcesContent":["  \n\n.bookings-widget {\n  overflow: hidden;\n\n  .bookings-container {\n    display: flex;\n    gap: 10px;\n    flex: 1;\n    min-height: 0;\n  }\n\n  .meetings-list-container {\n    flex: 1;\n    min-width: 0;\n    min-height: 0;\n    overflow-y: auto;\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none; /* IE/Edge */\n    &::-webkit-scrollbar {\n      display: none; /* Chrome, Safari, Opera */\n    }\n\n    .meetings-list {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      min-height: min-content;\n      &.no-meetings {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 16px;\n        text-align: center;\n        color: #666;\n        font-style: italic;\n        border-radius: 8px;\n\n      }\n      .meeting-item {\n        padding-left: 6px;\n        border-left: 4px solid;\n        display: block;\n        width: 100%;\n        background: none;\n        border-top: none;\n        border-right: none;\n        border-bottom: none;\n        font: inherit;\n        text-align: left;\n        cursor: pointer;\n\n        &.accepted {\n          border-left-color: var(--ion-color-success);\n        }\n\n        &.declined {\n          border-left-color: #ed143d;\n        }\n\n        &.pending {\n          border-left-color: var(--ion-color-warning);\n        }\n\n        &.resourceless {\n          border-left-color: #0078d4;\n        }\n\n        .meeting-subject {\n          display: block;\n          font-weight: 600;\n          font-size: 14px;\n          color: #333;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .meeting-time {\n          display: block;\n          font-size: 12px;\n          color: #888;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .meeting-resource {\n          font-size: 11px;\n          color: #888;\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n  }\n\n  .info-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    border-left: 3px solid #cccccc;\n    width: 120px;\n  }\n\n  .info-section {\n    text-align: center;\n    padding: 8px 4px;\n    border-radius: 8px;\n    line-height: 1.1;\n    .value {\n      font-size: clamp(16px, 2vw, 18px);\n      font-weight: 600;\n\n      &.booking-date-time {\n        display: flex;\n        font-size: 14px;\n        flex-direction: column;\n        align-items: center;\n        gap: 2px;\n        text-align: center;\n      }\n    }\n\n    .label {\n      font-size: clamp(10px, 1.5vw, 12px);\n      text-align: center;\n      color: #666;\n    }\n  }\n  .today-date-container {\n    font-size: 13px;\n    color: #ed143d;\n  }\n}\n\n.open-calendar-btn {\n  background: transparent;\n  font-size: 1.4rem;\n  ion-icon {\n    color: #ed143d;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
